import { render, staticRenderFns } from "./SidebarFormLighterBlue.vue?vue&type=template&id=8288169c&scoped=true&"
import script from "./SidebarFormLighterBlue.vue?vue&type=script&lang=js&"
export * from "./SidebarFormLighterBlue.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFormLighterBlue.vue?vue&type=style&index=0&id=8288169c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8288169c",
  null
  
)

export default component.exports